<main class="content">
  <app-ficha-etapas-cadastro
    titulo="Cadastrar Nova Ficha"
    [etapas]="etapas"
    [etapaAtual]="etapaAtual"
  ></app-ficha-etapas-cadastro>

  <section class="etapas">
    <app-breadcrumb
      [currentPage]="currentPageBreadcrumb"
      [currentPageDetail]="etapaAtual.descricao"
      voltar="hide"
      routerCurrentPage="/nova"
    >
    </app-breadcrumb>

    <app-selecionar-lojista-vendedor
      [operacao]="propostaCadastro.operacao"
      *ngIf="numeroEtapaAtual === 1"
      [formUpdateEmitter]="formUpdateEmitter"
      [solicitante]="solicitante"
      [(value)]="propostaCadastro.lojaVendedor"
      (valid)="formValid = $event"
    >
    </app-selecionar-lojista-vendedor>

    <app-dados-analise
      [parametroRendaProduto]="propostaCadastro.parametroRendaProduto"
      *ngIf="numeroEtapaAtual === 2"
      (next)="onClickNext()"
      (previous)="onClickPrevious()"
    >
    </app-dados-analise>

    <app-resultado-parcial
      [parametroRendaProduto]="propostaCadastro.parametroRendaProduto"
      [showLoaderPhases]="showLoaderPhases"
      *ngIf="numeroEtapaAtual === 3"
      (next)="onClickNext()"
      [showTryAgainButton]="showTryAgain"
      (analisarPropostaNovamente)="analisarPropostaAssincronaNovamente(disparoAnaliseAutomatica.RESULTADO_PARCIAL)"
    >
    </app-resultado-parcial>

    <app-detalhes-cliente
      *ngIf="numeroEtapaAtual === 4"
      [biometriaAtiva]="biometriaAtiva"
      (next)="onClickNext()"
      (previous)="onClickPrevious()"
    >
    </app-detalhes-cliente>

    <app-identificacao
      *ngIf="numeroEtapaAtual === 5"
      [numeroEtapaAtual]="numeroEtapaAtual"
      [showLoaderPhases]="showLoaderPhases"
      [biometriaAtiva]="biometriaAtiva"
      (next)="onClickNext()"
      (previous)="onClickPrevious()"
      [showTryAgainButton]="showTryAgain"
      (analisarPropostaNovamente)="analisarPropostaAssincronaNovamente(disparoAnaliseAutomatica.FINALIZAR_PROPOSTA)"
    >
    </app-identificacao>

    <app-analise *ngIf="numeroEtapaAtual === 6"> </app-analise>

    <app-botao-navegacao
      *ngIf="etapaNaoPossuiControleIndependente()"
      (previous)="onClickPrevious()"
      (next)="onClickNext()"
      [previousShow]="isShowButtonPrevious"
      [nextShow]="true"
      [nextEnabled]="formValid || numeroEtapaAtual === 6"
    >
    </app-botao-navegacao>
  </section>
</main>

<app-new-modal-message #dialog [showFecharBtn]="false"></app-new-modal-message>

<app-loader-circles *ngIf="showLoader"></app-loader-circles>